var _path, _ellipse, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorSetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77941 14.5202L9.78021 14.5211C9.88592 14.64 9.94641 14.7866 9.94641 14.9464C9.94641 15.2928 9.66777 15.5714 9.32141 15.5714C5.87005 15.5714 3.07141 12.7728 3.07141 9.32141C3.07141 5.87005 5.87005 3.07141 9.32141 3.07141C12.8299 3.07141 15.5714 5.58637 15.5714 8.57141C15.5714 10.3653 14.1153 11.8214 12.3214 11.8214H10.9939C10.0953 11.8214 9.36891 12.5478 9.36891 13.4464C9.36891 13.8636 9.53304 14.2417 9.77941 14.5202Z",
    stroke: "#4F4F4F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.227,
    cy: 8.4549,
    rx: 1.28571,
    ry: 1.28571,
    fill: "#4F4F4F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.79841,
    cy: 5.88349,
    rx: 1.28571,
    ry: 1.28571,
    fill: "#4F4F4F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6556,
    cy: 8.4549,
    rx: 1.28572,
    ry: 1.28571,
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSetIcon);
export default __webpack_public_path__ + "static/media/color-set-icon.4ad2883c3db0a0ef42bdf983a8bac7e8.svg";
export { ForwardRef as ReactComponent };